import * as React from 'react';
import { PaymentInstructionLayout } from '../../../component/PaymentInstructionLayout.js';

const Klarna = ()=>{
    return /*#__PURE__*/ React.createElement(PaymentInstructionLayout, {
        info: "checkout.payment.method.klarna.info"
    });
};

export { Klarna };
//# sourceMappingURL=Klarna.js.map
